import { StateProvinceModel } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class StateProvinceService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject';
    }

    retrieveStateProvinces(countryID?: number) {
        return this.$http<StateProvinceModel[]>({
            method: "GET",
            url: this.apexApiUrl + "state-provinces",
            params: { countryID: countryID },
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveStateProvince(stateProvinceID: number) {
        return this.$http<StateProvinceModel>({
            method: "GET",
            url: this.apexApiUrl + "state-provinces/" + stateProvinceID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    patchStateProvince(stateProvinceID: number, stateProvince: StateProvinceModel) {
        const data = {
            TaxRate1: stateProvince.TaxRate1,
            TaxRate2: stateProvince.TaxRate2,
            TaxRate3: stateProvince.TaxRate3
        };

        return this.$http<StateProvinceModel>({
            method: "PATCH",
            url: this.apexApiUrl + "state-provinces/" + stateProvinceID,
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            data: data
        }).then(() => {
            return this.retrieveStateProvince(stateProvinceID);
        });
    }
}
